// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1-e0F","label":"LabeledBox_label__2c1WL"};